import FormUpload from '@/components/common/FormUpload';
import useFormSubmit from '@/hooks/useFormSubmit';
import { updateLuckyBox } from '@/services/Box.service';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useMutation } from '@tanstack/react-query';
import { Modal, Form, Input, InputNumber, Select, Switch, Checkbox, Row, Col, Button, Tooltip } from 'antd';
import { useMemo } from 'react';

const modeOptions = [
  {
    label: 'Random trong khoảng min-max',
    value: 1,
  },
  {
    label: 'Random chọn min hoặc max',
    value: 2,
  },
  {
    label: 'Chọn max',
    value: 3,
  },
];

const boxTypeOptions = [
  {
    label: 'Normal Box',
    value: 1,
  },
  {
    label: 'Monthly Box',
    value: 2,
  },
];

export default function ModalEditBox({ onCancel, handleRefresh, initialValues }) {
  const [form] = Form.useForm();
  const luckyBoxMutation = useMutation({
    mutationFn: updateLuckyBox,
  });

  // const handleOnSubmit = useFormSubmit(
  //   luckyBoxMutation,
  //   async (values) => ({
  //     ...values,
  //     id: initialValues?.id,
  //   }),
  //   {
  //     onOk: async () => {
  //       onCancel();
  //       await handleRefresh();
  //     },
  //   }
  // );
  const handleOnSubmit = useFormSubmit(
    luckyBoxMutation,
    async (values) => {
      const image = values.image_path_reward?.[0];

      return {
        ...values,
        id: initialValues?.id,
        image_path_reward: image?.originFileObj || image?.url || null,
        is_special_month: values.is_special_month ? 1 : 0,
      };
    },
    {
      onOk: async () => {
        onCancel();
        await handleRefresh();
      },
    }
  );
  const formInitialValues = useMemo(
    () => ({
      ...initialValues,
      image_path_reward: initialValues?.image_path_reward
        ? [
          {
            uid: '-1',
            name: 'reward.png',
            status: 'done',
            url: `${process.env.REACT_APP_API_BASEURL}${initialValues.image_path_reward}`,
          },
        ]
        : [],
    }),
    [initialValues]
  );

  const hideIsdnWin = +initialValues?.box_type === 2 && +initialValues?.type === 2;

  return (
    <Modal
      title={`Edit Box (ID: ${initialValues?.id})`}
      open={true}
      width={850}
      destroyOnClose
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={() => form.submit()}>
          Save
        </Button>,
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={formInitialValues}
        onFinish={handleOnSubmit}
      >
        <Row gutter={20}>
          <Col span={12}>
            <Form.Item
              name="milestone"
              rules={[{ required: true }]}
              label={
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <span>Milestone</span>
                  <Tooltip title="Số mảnh cần có (200, 500, 1000...) để mở Box">
                    <ExclamationCircleOutlined
                      style={{ color: '#999', cursor: 'pointer' }}
                    />
                  </Tooltip>
                </div>
              }
            >
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="type" label="Type" rules={[{ required: true }]}>
              <Select
                options={[
                  {
                    label: 'Heart',
                    value: 1,
                  },
                  {
                    label: 'Money',
                    value: 2,
                  },
                ]}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="mode" label="Mode" rules={[{ required: true }]}>
              <Select options={modeOptions} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="min" label="Award Min">
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="max" label="Award Max">
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="rate" label="Rate (%)">
              <InputNumber min={0} max={100} style={{ width: '100%' }} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="total_key" label="Total Key">
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="box_type" label="Award Type">
              <Select options={boxTypeOptions} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="title_en" label="Title English">
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="title_my" label="Title Myanmar">
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Is Active" name="is_active" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Special Month" name="is_special_month" valuePropName="checked">
              <Checkbox>Enable</Checkbox>
            </Form.Item>
          </Col>
          <Col span={12}>
            {hideIsdnWin
              && (
                <Form.Item 
                label={
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <span>Total Winner</span>
                  <Tooltip title="Tổng số người có thể mở được giải đặc biệt">
                    <ExclamationCircleOutlined
                      style={{ color: '#999', cursor: 'pointer' }}
                    />
                  </Tooltip>
                </div>
              }
                name="total_winner">
                  <Input />
                </Form.Item>
              )
            }
          </Col>

          <Col span={12}>
            <Form.Item
              label="Image Reward"
              name="image_path_reward"
              valuePropName="fileList"
              getValueFromEvent={(e) => {
                console.log(1122, e);

                if (Array.isArray(e)) {
                  return e;
                }
                return e?.fileList;
              }}
              rules={[{ message: 'Please upload image', required: true }]}
            >
              <FormUpload className="w-[300px]" beforeUpload={() => false} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Description" name="description">
              <Input.TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
